import {
  CalculatorIcon,
  CheckboxIcon,
  DateIcon,
  DropdownIcon,
  PhotoIcon,
  TimeIcon,
  HashIcon,
  StarIcon,
  SignatureIcon,
  ShortTextIcon,
  SingleChoiceIcon,
  MultipleChoiceIcon,
  LongTextIcon,
  StaticTextIcon,
  TableIcon,
  LockIcon,
} from '@gocanvas/gcds/icons'

export const entryTypeIcons = {
  'Static Table': TableIcon,
  Calculation: CalculatorIcon,
  Checkbox: CheckboxIcon,
  Date: DateIcon,
  Dropdown: DropdownIcon,
  Photo: PhotoIcon,
  Time: TimeIcon,
  Signature: SignatureIcon,
  Number: HashIcon,
  Text: ShortTextIcon,
  Rating: StarIcon,
  'Single Choice': SingleChoiceIcon,
  'Multiple Choice': MultipleChoiceIcon,
  'Long Text': LongTextIcon,
  'Static Text': StaticTextIcon,
}

export const FieldIcon = ({ type = '', className = '', keyField = false }) => {
  const IconType = keyField ? LockIcon : entryTypeIcons[type] || ShortTextIcon
  const typeClass = `${type}`.toLowerCase().replace(/\W/g, '-')

  const mergedClassName = ['field--icon', `field--type-${typeClass}`, className]
    .filter(Boolean)
    .join(' ') // removes falsy values
  return <IconType className={mergedClassName} />
}
